import React from "react";
import { Chip } from "@mui/material";
import { formatPolicyEmploymentStatus } from "../../../utils/enumFormatter";
import { colorPolicyEmploymentStatus } from "../../../utils/colorEnumFormatter";
import { PolicyEmploymentStatus } from "../../../interfaces/DTO/mislaka_xml_pension_models";

interface EmploymentTypeChipProps {
  employmentType: PolicyEmploymentStatus;
  variant?: "filled" | "outlined";
  size?: "small" | "medium";
}

export const EmploymentTypeChip: React.FC<EmploymentTypeChipProps> = ({
  employmentType,
  variant = "outlined",
  size = "small",
}) => {
  const employmentTypeLabel = formatPolicyEmploymentStatus(employmentType);

  if (!employmentTypeLabel || employmentTypeLabel === "-") {
    return null;
  }

  const color = colorPolicyEmploymentStatus(employmentType);

  return (
    <Chip
      label={employmentTypeLabel}
      size={size}
      variant={variant}
      sx={{
        fontSize: "0.75rem",
        backgroundColor: variant === "filled" ? color : "transparent",
        color: variant === "filled" ? "white" : color,
        borderColor: variant === "outlined" ? color : undefined,
      }}
    />
  );
};
